import React from 'react';
import { Link } from 'react-router-dom';
import '../main-css/navigation.css';
import AniListLoginButton from './login-js/AniListLoginButton.js';

const Navigation = () => {
  return (
    <>
      <nav className="navbar">
      <div className="navbar-left">
        <img src="/Images/AnimeBibleLogoTP.png" alt="Anime Logo" className="logo-image" />
        <h1 className="logo-text">ANIMEBIBLE</h1>
      </div>
      <div className="navbar-center">
        <ul className="menu">
          <li className="menu-tile"><Link to="/" className="menu-link">Home</Link></li>
          <li className="menu-tile"><Link to="/chat" className="menu-link">Chatbot</Link></li>
          <li className="menu-tile"><Link to="/news" className="menu-link">NEWS</Link></li>
          <li className="menu-tile"><Link to="/shop" className="menu-link">SHOP</Link></li>
          <li className="menu-tile"><Link to="/valid/profile" className="menu-link">SETTINGS</Link></li>
        </ul>
      </div>
      <div className="navbar-right">
          <div className="icons">
            {/* Email Icon: Use 'mailto' for email link */}
            <span className="icon" title="Contact">
              <a href="mailto:contact.animebible@gmail.com">
                <img src="/Images/email.png" alt="Email" className="title-img" />
              </a>
            </span>
            {/* Patreon Icon: Link to your Patreon page */}
            <span className="icon" title="Patreon">
              <a href="https://www.patreon.com/profile/creators?u=149239669" target="_blank" rel="noopener noreferrer">
              <img src="/Images/patreon.png" alt="Patreon" className="title-img" />
              </a>
            </span>
            {/* Discord Icon: Link to your Discord server */}
            <span className="icon" title="Discord">
              <a href="https://discord.com/invite/B5yaNccrVR" target="_blank" rel="noopener noreferrer">
              <img src="/Images/discord.png" alt="Discord" className="title-img" />
              </a>
            </span>
            {/* Twitter Icon: Link to your Twitter page */}
            <span className="icon" title="Twitter">
              <a href="https://x.com/AnimeBible7" target="_blank" rel="noopener noreferrer">
              <img src="/Images/twitter.png" alt="Twitter" className="title-img" />
              </a>
            </span>
          </div>
          {/* AniList login button */}
          <AniListLoginButton />
        </div>
    </nav>

    {/* Privacy Policy and Terms Links */}
    <div className="policy-links">
      {/* Privacy Policy Link */}   
      <div className="privacy-policy-link">
        <a 
          href="https://www.termsfeed.com/live/eb3ecaac-5b7a-475e-bb8c-15ab5cc8f1f2" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
      </div>

      {/* Terms and Conditions Link */}
      <div className="terms-and-conditions-link">
        <a 
          href="/Images/AB-TermsCond.pdf" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Terms and Conditions
        </a>
      </div>
    </div>
   
  </>
  );
};

export default Navigation;